import popupModel from '@/model/popup';
import { apiRun } from '@/model/apiRun';
import BaseFormPopupWrappable from '@/components/base/BaseFormPopupWrappable.vue';

/**
 * CRUD справочника поверх конфига (src/config/dir/*).
 *
 * Живёт отдельным моделью, потому что одни и те же операции нужны и полю
 * BaseDir, и попапу со списком элементов.
 */
export default {
  /**
   * Открывает универсальную форму элемента. Можно звать и в обход справочника —
   * достаточно конфига с getFields().
   *
   * Редактируемый элемент уходит в getFields вторым аргументом: часть полей
   * существует только при правке. Так у клиента CRM появляется «Автор» —
   * при создании автором становится создатель, переназначить его можно только
   * потом (см. п. 3.16 описания прав).
   */
  openForm(config, { item = null, context = {} } = {}) {
    return popupModel.add({
      wrappable: true,
      component: BaseFormPopupWrappable,
      params: {
        title: config.itemTitle,
        fields: config.getFields(context, item),
        values: item ? config.getFormValues(item, context) : {},
      },
    });
  },

  /** Запрос с алертом при неудаче — см. model/apiRun.js. */
  run(action, errorText) {
    return apiRun(action, errorText);
  },

  async add(config, { filter = {}, context = {} } = {}) {
    const values = await this.openForm(config, { context });
    if (!values) return null;

    return this.run(
      () => config.create(values, filter, context),
      'Не удалось создать элемент справочника',
    );
  },

  async edit(config, item, { filter = {}, context = {} } = {}) {
    const loaded = await this.run(
      () => config.getItem(item.id),
      'Не удалось загрузить элемент справочника',
    );
    if (!loaded) return null;

    const values = await this.openForm(config, { item: loaded, context });
    if (!values) return null;

    return this.run(
      () => config.update(item.id, values, filter, context),
      'Не удалось сохранить элемент справочника',
    );
  },

  async remove(config, item) {
    const label = config.getLabel(item);
    const confirmed = await popupModel.addConfirm(
      'Удалить элемент справочника?',
      label,
    );
    if (!confirmed) return false;

    const result = await this.run(
      () => config.remove(item.id),
      'Не удалось удалить элемент справочника',
    );

    return result !== null;
  },
};
